import styled from "styled-components";
import { Typography } from "antd";

import { TypographyProps } from "./types";

export const Paragraph = styled(Typography.Paragraph)<TypographyProps>`
  color: ${({ theme }) => theme.colors.blueDianne};
  font-size: ${({ theme, size = "m" }) => theme.fontSize[size]};
  font-weight: 600;
  text-align: ${({ align }) => align};
  letter-spacing: 0.09em;

  .ant-btn-link {
    font-size: inherit;
    font-weight: 800;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
  }
`;
